import { UploadFileComponent } from "../../external/ensolvers-core-frontend-mui/components/Common/FormComponents";
import GenericForm from "../../external/ensolvers-core-frontend-mui/components/Common/GenericForm";
import NotificationService from "../../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/NotificationService";
import { traceo } from "../../external/ensolvers-core-frontend-mui/submodules/fox-typescript/utils/Logging";
import { EnsolversOpsUser } from "../../models/EnsolversOpsUser";
import { useStyles } from "../Main/formStyles";
import { SpinnerWrapper } from "../SpinnerWrapper";
import { Token } from "../../theme";
import OpsImageService from "../../services/OpsImageService";
import useUserAvatar from "../../hooks/useUserAvatar";

interface Props {
  userAvatarUpdate: EnsolversOpsUser | undefined;
  isLoading: boolean;
  setIsLoading(value: boolean): void;
  setUserAvatarUpdate(value: EnsolversOpsUser | undefined): void;
  setUser(value: EnsolversOpsUser | undefined): void;
}

export const UserAvatar = ({ userAvatarUpdate, isLoading, setIsLoading, setUserAvatarUpdate, setUser }: Props) => {
  const customStyles = useStyles();
  const { handleSaveAvatar, handleCancel } = useUserAvatar({ userAvatarUpdate, setIsLoading, setUserAvatarUpdate, setUser });

  return (
    <>
      {userAvatarUpdate && (
        <GenericForm<File>
          headerStyles={{ color: Token.textPrimary, marginBottom: -10, marginTop: 10 }}
          buttonStyles={{ marginRight: 20, color: "white", backgroundColor: Token.actionPrimary, marginBottom: 10 }}
          cancelButtonStyles={{
            color: Token.textSecondary,
            border: `1px solid ${Token.borderDefault}`,
            marginBottom: 10,
          }}
          dialogStyles={customStyles.root}
          dialog={true}
          open={true}
          title={"Edit avatar"}
          onSave={handleSaveAvatar}
          onCancel={handleCancel}
          renderContent={(register, errors, control) => (
            <SpinnerWrapper isLoading={isLoading}>
              <UploadFileComponent propertyName={"file"} label="" required={true} />
            </SpinnerWrapper>
          )}
        />
      )}
    </>
  );
};
